<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MKTReport/SurveyOnOffPremise'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทงาน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reObjectivesCode'"
                    :name="'reObjectivesCode'"
                    :select2-options="reObjectivesCodeOptions"
                    v-model="reObjectivesCode"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group ">
                  <label class="label">วันที่เช็คอินเริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reStartDate"
                      name="reStartDate"
                      ref="reStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">วันที่เช็คอินสิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reEndDate"
                      name="reEndDate"
                      ref="reEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCodes'"
                    :name="'reAgentCodes'"
                    :select2-options="reAgentCodesOptions"
                    multiple
                    v-model="reAgentCodes"
                  ></select2> -->
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ชื่อเจ้าหน้าที่:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reUserIds'"
                    :name="'reUserIds'"
                    :select2-options="reUserIdsOptions"
                    v-model="reUserIds"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportSurveyOnOffPremise"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="SurveyOnOffPremiseTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="26">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">ประเภทงาน</th>
                    <th class="all text-center">ชื่อเจ้าหน้าที่</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">วันที่เช็คอิน</th>
                    <th class="all text-center">ระยะเวลาที่เข้าทำงาน</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">PG เชียร์ขาย</th>
                    <th class="all text-center">จำนวนPG เชียร์ขาย</th>
                    <th class="all text-center">ยอดขาย(ถัง)</th>
                    <th class="all text-center">จำนวนถัง</th>
                    <th class="all text-center">หัวจ่าย</th>
                    <th class="all text-center">จำนวนหัวจ่าย</th>
                    <th class="all text-center">ทาวเวอร์</th>
                    <th class="all text-center">จำนวนทาวเวอร์</th>
                    <th class="all text-center">เหยือก</th>
                    <th class="all text-center">จำนวนเหยือก</th>
                    <th class="all text-center">แก้ว</th>
                    <th class="all text-center">จำนวนแก้ว</th>
                    <th class="all text-center">โต๊ะ</th>
                    <th class="all text-center">จำนวนโต๊ะ</th>
                    <th class="all text-center">เก้าอี้</th>
                    <th class="all text-center">จำนวนเก้าอี้</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaDateReq: null,
      reObjectivesCode: null,
      reStartDate: null,
      reEndDate: null,
      reAgentCodes: [],
      reUserIds: null,
      reAgentCodesOptions: [],
      reIsInitial: true,
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_MKT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reUserIdsOptions: {
        placeholder: "กรุณาเลือกเจ้าหน้าที่",
        allowClear: true,
        ajax: {
          delay: 300,
          method: "post",
          url: "/Api/Users/Select2UserMkt",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              agentCodes: self.reAgentCodes,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reObjectivesCodeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          {
            id: "MKT_ACTIVITY_TYPE_SURVEY_ON_PREMISE",
            text: "ตรวจเยี่ยมร้าน On-premise",
            data: null,
          },
          {
            id: "MKT_ACTIVITY_TYPE_SURVEY_OFF_PREMISE",
            text: "ตรวจเยี่ยมร้าน Off-premise",
            data: null,
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reObjectivesCode = null;
      self.reAgentCodes = [];
      self.reUserIds = null;

      $("#reStartDate")
        .val("")
        .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      $("#reObjectivesCode")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      $("#reUserIds")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#SurveyOnOffPremiseTable").DataTable();
      table.draw();
    },
    exportSurveyOnOffPremise: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportMKTSurvey",
        responseType: "arraybuffer",
        data: {
          CheckInStartDate:
            self.reStartDate != null
              ? self.reStartDate.format("DD/MM/YYYY")
              : self.reStartDate,
          CheckInEndDate:
            self.reEndDate != null
              ? self.reEndDate.format("DD/MM/YYYY")
              : self.reEndDate,
          CreatedUserId: self.reUserIds,
          ObjectivesCode: self.reObjectivesCode,
          AgentCode: self.reAgentCodes,
          IsInitial: self.reIsInitial,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_MKT", {
          province_id: [],
          department: [],
          AgentCodes: [],
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;

    self.LoadreAgentCodesOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#SurveyOnOffPremiseTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/MKTSurvey",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              CheckInStartDate:
                self.reStartDate != null
                  ? self.reStartDate.format("DD/MM/YYYY")
                  : self.reStartDate,
              CheckInEndDate:
                self.reEndDate != null
                  ? self.reEndDate.format("DD/MM/YYYY")
                  : self.reEndDate,
              CreatedUserId: self.reUserIds,
              ObjectivesCode: self.reObjectivesCode,
              AgentCode: self.reAgentCodes,
              IsInitial: self.reIsInitial,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[0, "asc"]],
        columns: [
          {
            data: "activityHeaderId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "objectivesName", className: "text-center" },
          { data: "createdName", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "provinceName", className: "text-center", orderable: false },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
          {
            data: "checkIn",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.checkInString;
            },
          },
          { data: "timeUsage", className: "text-center" },
          { data: "shopTypeName", className: "text-center" },
          { data: "pgSaleItem", className: "text-center", orderable: false },
          {
            data: "pgSaleItemQty",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "saleItem", className: "text-center", orderable: false },
          {
            data: "saleItemQty",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "dispenser", className: "text-center", orderable: false },
          {
            data: "dispenserQty",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "tower", className: "text-center", orderable: false },
          {
            data: "towerQty",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "pitcher", className: "text-center", orderable: false },
          {
            data: "pitcherQty",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "glass", className: "text-center", orderable: false },
          {
            data: "glassQty",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "tables", className: "text-center", orderable: false },
          {
            data: "tableQty",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "chair", className: "text-center", orderable: false },
          {
            data: "chairQty",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
        ],
        drawCallback: function(settings) {
          self.reIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/SurveyOnOffPremise.vue